import { BooleanInput, TextInput } from "react-admin";
import {
	alphanumericWordsValidator,
	emailValidator,
	kidValidator,
} from "../../validators";

type UserFieldsProps = {
	showAdminField: boolean;
};

export const UserForm = ({ showAdminField }: UserFieldsProps) => (
	<>
		<TextInput
			source="first_name"
			validate={alphanumericWordsValidator}
			fullWidth
		/>
		<TextInput
			source="last_name"
			validate={alphanumericWordsValidator}
			fullWidth
		/>
		<TextInput source="kid" label="K-ID" validate={kidValidator} fullWidth />
		<TextInput source="email" validate={emailValidator} fullWidth />
		<TextInput
			source="department"
			validate={alphanumericWordsValidator}
			fullWidth
		/>
		{showAdminField && <BooleanInput source="admin" />}
	</>
);
